// frontend/src/components/client/PaymentContact.jsx
import React, { useState, useEffect } from 'react';
import { Phone, Shield, Clock, AlertCircle } from 'lucide-react';
import { clientAPI } from '../../services/api';

const PaymentContact = () => {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

 useEffect(() => {
  const fetchContact = async () => {
    try {
      const res = await clientAPI.getDefaultContact();
      setContact(res.data.data);
    } catch (err) {
      console.error('Failed to load contact info:', err);
    } finally {
      setLoading(false);
    }
  };
  fetchContact();
}, []);

  const divisionName = contact?.division || 'Civil Services Division';
  const phone        = contact?.paymentContactPhone || contact?.phone || '555-555-5555';
  const officerName  = contact?.name || '';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full">

        {/* Header badge */}
        <div className="flex justify-center mb-6">
          <div className="flex items-center gap-2 bg-blue-900 text-white text-xs font-semibold px-4 py-2 rounded-full tracking-wide uppercase">
            <Shield className="w-4 h-4" />
            <span>Secure Payment Portal</span>
          </div>
        </div>

        {/* Main card */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

          {/* Top banner */}
          <div className="bg-blue-900 px-6 py-5 text-center">
            <h1
              className="text-white text-2xl font-bold mb-1"
              style={{ fontFamily: 'Times New Roman, serif' }}
            >
              Online Payment Center
            </h1>
            <p className="text-blue-200 text-sm">Access Restricted</p>
          </div>

          {/* Body */}
          <div className="px-6 py-8 text-center">

            {/* Alert icon */}
            <div className="flex justify-center mb-5">
              <div className="w-16 h-16 bg-amber-50 border-2 border-amber-400 rounded-full flex items-center justify-center">
                <AlertCircle className="w-8 h-8 text-amber-500" />
              </div>
            </div>

            <h2
              className="text-xl font-bold text-gray-800 mb-3"
              style={{ fontFamily: 'Times New Roman, serif' }}
            >
              Action Required
            </h2>

            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              To access the{' '}
              <span className="font-semibold text-gray-800">Online Payment Center</span>,
              you must first contact the{' '}
              <span className="font-semibold text-blue-900">{divisionName}</span>.
              A case number must be assigned to your profile before you can proceed with payment.
            </p>

            {/* Phone card */}
{/* Phone card */}
            <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-6">
            {loading ? (
                <div className="flex justify-center py-2">
                <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                </div>
            ) : (
                <div>
                <p className="text-xs text-gray-500 uppercase tracking-widest mb-3 font-semibold">
                    Contact Number
                </p>

                <a
                    href={"tel:" + phone.replace(/\D/g, '')}
                    className="flex items-center justify-center gap-3 text-blue-900 hover:text-blue-700 transition-colors"
                >
                    <div className="w-10 h-10 bg-blue-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-5 h-5 text-white" />
                    </div>
                    <span className="text-2xl font-bold tracking-wide">{phone}</span>
                </a>

                {officerName && (
                    <p className="text-xs text-gray-500 mt-3">
                    Ask for:{' '}
                    <span className="font-semibold text-gray-700 uppercase">{officerName}</span>
                    </p>
                )}

                <p className="text-xs text-gray-500 mt-1">
                    <span className="font-semibold text-gray-700">{divisionName}</span>
                </p>
                </div>
            )}
            </div>

            {/* Hours note */}
            <div className="flex items-start gap-2 bg-blue-50 border border-blue-100 rounded-lg px-4 py-3 text-left">
              <Clock className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
              <p className="text-xs text-blue-800 leading-relaxed">
                Office hours are{' '}
                <span className="font-semibold">Monday – Friday, 8:00 AM – 5:00 PM</span>.
                Please have your case information ready when you call.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t border-gray-100 px-6 py-4 bg-gray-50 text-center">
            <p className="text-xs text-gray-400 leading-relaxed">
              This page is part of a secure federal payment system. Unauthorized access is prohibited.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default PaymentContact;